"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const joi_1 = __importDefault(require("joi"));
const ChargeStatus_1 = require("../models/charges/ChargeStatus");
const rates_1 = require("../models/rates");
const GenericValidator_1 = __importDefault(require("./GenericValidator"));
class BatchEditChargesValidator extends GenericValidator_1.default {
    transactionTypes = Object.values(rates_1.TransactionType);
    chargeStatus = Object.values(ChargeStatus_1.ChargeStatus);
    _batchEditChargesSchema = joi_1.default.object({
        transactionType: joi_1.default.string()
            .valid(...this.transactionTypes)
            .optional(),
        status: joi_1.default.string()
            .valid(...this.chargeStatus)
            .optional(),
        category: joi_1.default.string().optional(),
        transactionId: joi_1.default.number().optional(),
        trackingNumber: joi_1.default.string().optional(),
        glAccount: joi_1.default.string().optional(),
        chargeIds: joi_1.default.array()
            .items(joi_1.default.string())
            .min(1)
            .max(500)
            .unique()
            .required(),
    }).required();
    validate(batchEditCharges) {
        super.validate(batchEditCharges, 'IBatchEditCharges', this._batchEditChargesSchema);
    }
}
exports.default = BatchEditChargesValidator;
